import {createApp} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import axiosClient from '../modules/axiosClient';

const app = createApp({
    props: ['initialResults', 'search'],
    propsData: window.propsData,
    data() {
        return {
            searchField: '',
            searchedKeyword: '',
            results: [],
            noMoreResults: false,
            limit: 10,
            loading: false,
        };
    },
    methods: {
        updateResults() {
            this.loading = true;
            this.searchedKeyword = this.searchField;
            this.results = [];
            this.updatePageUrl();
            this.getMoreResults();
        },
        updatePageUrl() {
            // Update URL
            const urlKeyword = this.searchedKeyword.trim().replace(' ', '+').toLowerCase();

            const urlQuery = new URLSearchParams(window.location.search);
            if (urlQuery.has('s')) {
                urlQuery.set('s', urlKeyword);
            } else {
                urlQuery.append('s', urlKeyword);
            }

            const newUrl = window.location.origin + window.location.pathname + '?' + urlQuery.toString();
            window.history.pushState('', '', newUrl);
            if (window.ga !== undefined) {
                window.ga('set', 'page', window.location.pathname + '?' + urlQuery.toString());
                window.ga('send', 'pageview');
            }
        },
        getMoreResults() {
            this.loading = true;

            const searchApiUrl = '/api/search/' + this.searchedKeyword + '/' + this.limit + '/' + this.results.length;

            axiosClient.post(searchApiUrl, {}).then((response) => {
                this.results = this.results.concat(response.data);
                this.noMoreResults = response.data.length < this.limit;
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    mounted() {
        this.results = this.initialResults;
        this.searchField = this.search;
        this.searchedKeyword = this.search;
        this.noMoreResults = (this.results.length < this.limit) && this.search.length;
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);

app.mount('#search-container');
